import React, { useState, useEffect } from "react";
import { Box, Grid, Typography, Card, TextField, Button, Checkbox, FormControlLabel, MenuItem, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";

const OlympiadShipmentModal = ({ closePopup, modalData }) => {
    const [items, setItems] = useState({});
    const [selectedItems, setSelectedItems] = useState({});
    const [enteredItems, setEnteredItems] = useState({});
    const [step, setStep] = useState(1);
    const [trackingData, setTrackingData] = useState([]);
    const [attachmentData, setAttachmentData] = useState([]);
    const [previewImage, setPreviewImage] = useState(null);
    const [deletedAttachments, setDeletedAttachments] = useState([]);
    const [trackingForm, setTrackingForm] = useState({
        trackingNo: "",
        courier: "",
        dispatchDate: "",
        deliveryDate: "",
        parcelCount: "",
        status: "", // shipped / delivered
        proof: null
    });
    const [deliveryStatus, setDeliveryStatus] = useState(3);

    // const handleTrackingChange = (key, value) => {
    //     setTrackingForm((prev) => ({
    //         ...prev,
    //         [key]: value
    //     }));
    // };

    const handleTrackingChange = (key, value) => {

        if (key === "status") {
            if (value === "shipped") setDeliveryStatus(3);
            else if (value === "delivered") setDeliveryStatus(4);
        }
        setTrackingForm((prev) => {
            let updated = { ...prev, [key]: value };

            // ✅ if dispatch changes → fix delivery if invalid
            // if (key === "dispatchDate" && updated.deliveryDate) {
            //     if (updated.deliveryDate < value) {
            //         const dispatch = new Date(value);
            //         const estimated = new Date(dispatch);
            //         estimated.setDate(dispatch.getDate() + 3);

            //         updated.deliveryDate = estimated.toISOString().split("T")[0];
            //     }
            // }

            return updated;
        });
    };

    useEffect(() => {
        if (trackingForm.dispatchDate) {
            const dispatch = new Date(trackingForm.dispatchDate);

            const estimated = new Date(dispatch);
            estimated.setDate(dispatch.getDate() + 3);

            const formatted = estimated.toISOString().split("T")[0];

            setTrackingForm((prev) => ({
                ...prev,
                deliveryDate: formatted
            }));
        }
    }, [trackingForm.dispatchDate]);

    const handleRemoveAttachment = (index) => {
        const isSuccess = window.confirm("Are you sure you want to delete this image?");

        if (!isSuccess) return;

        setAttachmentData((prev) => {
            const removed = prev[index];

            if (!removed.file) {
                setDeletedAttachments((d) => [...d, removed]);
            }

            return prev.filter((_, i) => i !== index);
        });
    };

    useEffect(() => {
        if (modalData?.shipmentItemes?.itemsNameWithId) {
            const initialItems = {};

            modalData.shipmentItemes.itemsNameWithId.forEach((item) => {
                if (item.id == 1) {
                    initialItems[item.name] =
                        modalData?.shipmentItemes?.totalStudyMaterial || 0;
                } else if (item.id == 6) {
                    initialItems[item.name] = 0;
                } else {
                    initialItems[item.name] =
                        modalData?.shipmentItemes?.totalStudent || 0;
                }
            });

            setItems(initialItems);
        }
    }, [modalData]);

    const handleChange = (key, value) => {
        if (key === "Others") {
            setEnteredItems((prev) => ({
                ...prev,
                [key]: value,
            }));
            return;
        }

        const maxValue = items[key] || 0;

        if (value === "") {
            setEnteredItems((prev) => ({
                ...prev,
                [key]: "",
            }));
            return;
        }

        let finalValue = Number(value);

        if (finalValue < 0) finalValue = 0;
        if (finalValue > maxValue) finalValue = maxValue;

        setEnteredItems((prev) => ({
            ...prev,
            [key]: finalValue,
        }));
    };

    const handleCheckboxChange = (name) => {
        setSelectedItems((prev) => {
            const newValue = !prev[name];

            if (newValue) {
                setEnteredItems((prevEntered) => ({
                    ...prevEntered,
                    [name]: items[name] === 0 ? "" : items[name]
                }));
            }

            return {
                ...prev,
                [name]: newValue,
            };
        });
    };

    const handleAddTracking = () => {
        console.log(selectedItems, "lkkdhnskjdbaskdbksjdb")
        const selectedKeys = Object.keys(selectedItems).filter(
            (key) => selectedItems[key]
        );

        if (selectedKeys.length === 0) {
            alert("Please select at least one item");
            return;
        }
        for (let key of selectedKeys) {
            const value = enteredItems[key];

            const isOthers = modalData?.shipmentItemes?.itemsNameWithId?.find(
                (i) => i.name === key
            )?.id === 6;

            if (isOthers) {
                if (!value || value.trim() === "") {
                    alert("Please enter value for Others");
                    return;
                }
            } else {
                if (!value || Number(value) <= 0) {
                    alert(`Please enter valid count for ${key}`);
                    return;
                }
            }
        }
        // const selectedData = Object.keys(selectedItems)
        //     .filter((key) => selectedItems[key])
        //     .map((key) => ({
        //         name: key,
        //         count: key === "Others"
        //             ? enteredItems[key] || ""
        //             : enteredItems[key] || 0
        //     }));
        // setTrackingData(selectedData);

        const selectedData = Object.keys(selectedItems)
            .filter((key) => selectedItems[key])
            .map((key) => {
                const itemObj = modalData?.shipmentItemes?.itemsNameWithId?.find(
                    (i) => i.name === key
                );

                return {
                    id: itemObj?.id,   // ✅ include id
                    name: key,
                    count: key === "Others"
                        ? enteredItems[key] || ""
                        : enteredItems[key] || 0
                };
            });

        setTrackingData(selectedData);

        setStep(2); // ✅ move to next screen
    };

    // const submitFinalTracking = async () => {
    //     const finalPayload = {
    //         items: trackingData,
    //         tracking: trackingForm,
    //         attachmentData: attachmentData,
    //         regId: modalData?.regId
    //     };
    //     console.log("FINAL DATA:", finalPayload);
    //       const formData = new FormData();
    //                 formData.append("files", attachmentData);
    //                 formData.append("regId", modalData?.regId);
    //                 formData.append("items", trackingData);
    //                 formData.append("tracking", trackingForm);

    //                  await window.Platform.database.createShipment(formData);


    // }
    const submitFinalTracking = async () => {
        if (!trackingForm.trackingNo?.trim()) {
            window.alert("Tracking Number Must be entered");
            return;
        }
        if (!trackingForm.courier?.trim()) {
            window.alert("Enter Courier");
            return;
        }
        if (!trackingForm.status?.trim()) {
            window.alert("Please Fill Delivery Status");
            return;
        }
        if (!trackingForm.dispatchDate?.trim()) {
            window.alert("Please Fill Dispatch Date");
            return;
        }
        if (!trackingForm.deliveryDate?.trim()) {
            window.alert("Please Fill Delivery Date");
            return;
        }
        if (!trackingForm.parcelCount?.trim()) {
            window.alert("Enter Parcel Count");
            return;
        }
        if(attachmentData?.length <= 0){
             window.alert("Please Uplaoad Attachemnt");
            return;
        }
        const filteredTrackingData = trackingData.filter(
            (item) => item.name !== "Others"
        );

        const allZero = filteredTrackingData.every(
            (item) => Number(item.count || 0) === 0
        );

        let deliveryStatus;

        if (allZero) {
            deliveryStatus = trackingForm.status === "delivered" ? 4 : 3;
        } else {
            if (trackingForm.status === "shipped") {
                deliveryStatus = 3
            }
            else if (trackingForm.status === "delivered") {
                deliveryStatus = 8
            }

        }

        const formData = new FormData();

        attachmentData.forEach((fileObj) => {
            console.log(fileObj, "fileObj")
            if (fileObj.file instanceof File) {
                formData.append("files", fileObj.file);
            }
        });

        formData.append("regId", modalData?.regId);
        formData.append("deliveryStatus", deliveryStatus);

        formData.append("items", JSON.stringify(trackingData));
        formData.append("tracking", JSON.stringify(trackingForm));

        try {
            const res = await window.Platform.database.createShipment(formData);

            if (res.status) {
                window.NotificationUtils.showSuccess(res?.message || "Successfully Done");
                closePopup();
            } else {
                window.NotificationUtils.showError(res?.message || "Something went wrong");
            }
        } catch (err) {
            console.error(err);
            window.NotificationUtils.showError("API Failed");
        }
    };

    useEffect(() => {
        return () => {
            attachmentData.forEach(att => {
                if (att.file) URL.revokeObjectURL(att.preview);
            });
        };
    }, [attachmentData]);

        const formatDate = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric"
        });
    };
    
    return (
        <Box p={3}>
            <IconButton
                onClick={closePopup}
                sx={{
                    position: "absolute",
                    right: 8,
                    top: 8
                }}
            >
                <CloseIcon />
            </IconButton>
            {step == 1 ? <>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center", fontSize: "20px", fontWeight: "600", marginBottom: "10px" }}>
                    Item Shipment ({modalData?.rno_id})
                </div>
                <Card sx={{ p: 3, mb: 3, background: "#e8f5e9" }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <p> School name: -   ({modalData?.partyId || ""}) {modalData?.schoolName || "N/A"}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> RM name: -  ({modalData?.userId || ""}) {modalData?.userName || "N/A"}</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <p> Date Of Olympiad: -   {formatDate(modalData?.olympiad_date)}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> Total Students: - {modalData?.shipmentItemes?.totalStudent || 0}</p>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <p> Medium: -   {modalData?.reg_medium_name || "N/A"}</p>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <p> Total Books: -  {modalData?.shipmentItemes?.totalStudyMaterial || 0}</p>
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <p>
                                Classes Opted: -
                                {
                                    modalData?.lineItems?.length
                                        ? modalData.lineItems.map((ele, ind) => (
                                            <span key={ind}>{ele?.className}{ind !== modalData.lineItems.length - 1 ? ", " : ""}</span>
                                        ))
                                        : "N/A"
                                }
                            </p>
                        </Grid>

                        <Grid item xs={12} md={12}>
                            <p>
                                Subjects Opted: -
                                {
                                    modalData?.lineItems?.length
                                        ? modalData.lineItems.map((ele, ind) => (
                                            <span key={ind}>{ele?.subjectName}{ind !== modalData.lineItems.length - 1 ? ", " : ""}</span>
                                        ))
                                        : "N/A"
                                }
                            </p>
                        </Grid>
                    </Grid>
                </Card>
                <Grid container spacing={2}>
                    {modalData?.shipmentItemes?.itemsNameWithId?.map((item) => (
                        <Grid item xs={12} sm={6} md={4} key={item.id}>
                            <Card sx={{ p: 2 }}>
                                <Typography fontWeight="bold">{item.name}</Typography>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!!selectedItems[item.name]}
                                            onChange={() => handleCheckboxChange(item.name)}
                                        />
                                    }
                                    label={`${item.name} (${item.id == 1
                                        ? modalData?.shipmentItemes?.totalStudyMaterial || 0
                                        : item.id == 6
                                            ? 0
                                            : modalData?.shipmentItemes?.totalStudent || 0
                                        })`}
                                />
                                {selectedItems[item.name] && (
                                    <TextField
                                        label={item.id == 6 ? "Enter Item (e.g. Chalk 12)" : "Enter Delivery Count"}
                                        type={item.id == 6 ? "text" : "number"}   // ✅ dynamic type
                                        size="small"
                                        fullWidth
                                        inputProps={
                                            item.id == 6
                                                ? {}
                                                : { min: 0, max: items[item.name] || 0 }
                                        }
                                        onWheel={(e) => e.target.blur()}
                                        value={enteredItems[item.name] ?? ""}
                                        onChange={(e) =>
                                            handleChange(item.name, e.target.value)  // ✅ no Number()
                                        }
                                        sx={{ mt: 1 }}
                                    />
                                )}
                            </Card>
                        </Grid>
                    ))}
                </Grid>
                <Box mt={3} display="flex" gap={2}>
                    <Button variant="contained" onClick={handleAddTracking} alignItems="center">
                        Add Tracking Detail
                    </Button>
                </Box>
            </>
                :
                <Box p={3}>
                    <Typography variant="h6" mb={2}>
                        Update Tracking Details
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Tracking No."
                                fullWidth
                                size="small"
                                value={trackingForm.trackingNo}
                                onChange={(e) => handleTrackingChange("trackingNo", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Courier"
                                fullWidth
                                size="small"
                                value={trackingForm.courier}
                                onChange={(e) => handleTrackingChange("courier", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={12}>
                            <TextField
                                label="Delivery Status"
                                select
                                fullWidth
                                size="small"
                                label="Delivery Status"
                                value={trackingForm.status}
                                onChange={(e) => { handleTrackingChange("status", e.target.value) }}
                            >
                                <MenuItem value="shipped">Shipped</MenuItem>
                                <MenuItem value="delivered">Delivered</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Dispatch Date"
                                type="date"
                                fullWidth
                                size="small"
                                inputProps={{
                                    min: new Date().toISOString().split("T")[0] // ✅ today as minimum
                                }}
                                InputLabelProps={{ shrink: true }}
                                value={trackingForm.dispatchDate}
                                onChange={(e) => handleTrackingChange("dispatchDate", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            {/* <TextField
                                label="Estimated Delivery Date"
                                type="date"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                value={trackingForm.deliveryDate}
                                onChange={(e) => { setIsDeliveryEdited(true); handleTrackingChange("deliveryDate", e.target.value)}}
                            /> */}
                            <TextField
                                label="Estimated Delivery Date"
                                type="date"
                                fullWidth
                                size="small"
                                InputLabelProps={{ shrink: true }}
                                inputProps={{
                                    min: trackingForm.dispatchDate || new Date().toISOString().split("T")[0]
                                }}
                                value={trackingForm.deliveryDate}
                                onChange={(e) => {
                                    const value = e.target.value;

                                    // ❌ prevent smaller than dispatch
                                    if (trackingForm.dispatchDate && value < trackingForm.dispatchDate) {
                                        alert("Delivery date cannot be before dispatch date");
                                        return;
                                    }

                                    handleTrackingChange("deliveryDate", value);
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <TextField
                                label="Parcel Count"
                                type="number"
                                onWheel={(e) => e.target.blur()}
                                fullWidth
                                size="small"
                                value={trackingForm.parcelCount}
                                onChange={(e) => handleTrackingChange("parcelCount", e.target.value)}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button variant="outlined" component="label">
                                Upload Attachment
                                <input
                                    type="file"
                                    multiple
                                    hidden
                                    onChange={(e) => {
                                        const files = Array.from(e.target.files);

                                        const mappedFiles = files.map((file) => ({
                                            file: file,
                                            name: file.name,
                                            path: `${window.Platform.database.funcForBaseURL()}/file/${file.name}`
                                        }));

                                        setAttachmentData((prev) => [...prev, ...mappedFiles]);
                                    }}
                                />
                            </Button>
                            {attachmentData.length > 0 && (
                                <Box mt={1}>
                                    <Grid container spacing={2} mt={1}>
                                        {attachmentData.map((att, i) => {
                                            const imageUrl = att.file
                                                ? URL.createObjectURL(att.file) // new upload preview
                                                : `${window.Platform.database.funcForBaseURL()}/file/${att.name}`;

                                            return (
                                                <Grid item xs={3} key={i}> {/* 12/4 = 3 per row */}
                                                    <Box textAlign="center">
                                                        <DeleteIcon
                                                            onClick={() => handleRemoveAttachment(i)}
                                                            style={{
                                                                position: "absolute",
                                                                cursor: "pointer",
                                                                color: "#d90000",
                                                                background: "#fff",
                                                                borderRadius: "50%"
                                                            }}
                                                        />
                                                        <img
                                                            src={imageUrl}
                                                            alt={att.name}
                                                            onClick={() => setPreviewImage(imageUrl)}
                                                            style={{
                                                                width: "100%",
                                                                height: "120px",
                                                                objectFit: "cover",
                                                                borderRadius: "8px",
                                                                cursor: "pointer",
                                                                border: "1px solid #ccc"
                                                            }}
                                                        />
                                                        <Typography variant="caption">
                                                            {att.name}
                                                        </Typography>
                                                    </Box>
                                                </Grid>
                                            );
                                        })}
                                    </Grid>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                    <Box mt={3} display="flex" gap={2}>
                        <Button variant="outlined" onClick={() => setStep(1)}>
                            Back
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            onClick={() => { submitFinalTracking() }}
                        >
                            Submit
                        </Button>
                    </Box>
                </Box>
            }
            <Box display="flex" justifyContent="center" mt={2}>
                <Typography fontWeight="bold">
                    Step {step} of 2
                </Typography>
            </Box>
        </Box>
    );
};

export default OlympiadShipmentModal;